import { useCallback } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

export default function useQueryParam(paramName) {
  const navigate = useNavigate();
  const location = useLocation();

  const getQueryParam = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);

    return searchParams.get(paramName);
  }, [location.search, paramName]);

  const removeQueryParam = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);

    // Remove the query parameter
    searchParams.delete(paramName);

    // Construct the new search string
    const newSearch = searchParams.toString();

    // Navigate to the new URL with updated query parameters
    navigate(`${location.pathname}?${newSearch}`);
  }, [location.pathname, location.search, navigate, paramName]);

  const addQueryParam = useCallback(() => {
    const searchParams = new URLSearchParams(location.search);

    // Add or update the query parameter
    searchParams.set(paramName, true);

    // Construct the new search string
    const newSearch = searchParams.toString();

    // Navigate to the new URL with updated query parameters
    navigate(`${location.pathname}?${newSearch}`);
  }, [location.pathname, location.search, navigate, paramName]);

  return {
    addQueryParam,
    getQueryParam,
    removeQueryParam,
  };
}
